import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import QRCode from 'qrcode';

function QrCode({ code, loadingComp, qrCodeConfig, className }) {
    const [isQRCodeLoading, setIsQRCodeLoading] = useState(true);
    const [QRCodeSrc, setQRCodeSrc] = useState('');
    const generateQRCode = useCallback(
        async value => {
            try {
                const QR_CODE_OPTIONS = {
                    errorCorrectionLevel: 'L',
                    type: 'image/jpeg',
                    quality: 1,
                    margin: 0,
                    ...qrCodeConfig
                };
                return await QRCode.toDataURL(value, QR_CODE_OPTIONS);
            } catch (err) {
                console.log(err);
            }
        },
        [qrCodeConfig]
    );

    useEffect(() => {
        let isUnmount = false;
        const getQRCodeInfo = async () => {
            const QRCodeBase64 = await generateQRCode(code);
            if (!isUnmount) {
                setQRCodeSrc(QRCodeBase64);
                setIsQRCodeLoading(false);
            }
        };
        getQRCodeInfo();
        return () => (isUnmount = true);
    }, [generateQRCode, code]);

    return isQRCodeLoading ? (
        loadingComp
    ) : (
        <img className={className} src={QRCodeSrc} alt="qrCode" />
    );
}

QrCode.propTypes = {
    code: PropTypes.string,
    loadingComp: PropTypes.node,
    qrCodeConfig: PropTypes.object,
    className: PropTypes.string
};

export default QrCode;
